import React, { useEffect, useMemo } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { mod } from 'react-swipeable-views-core';
import { virtualize } from 'react-swipeable-views-utils';
import { appendClassProps } from '../util';
import Pagination from './Pagination';
const InfiniteSwipeableViews = virtualize(SwipeableViews); // ts hack because we don't want to use the index prop, which is required in the type defs of this lib
//  (we don't want a controlled component or circular animations break)
/**
 * Takes any number (positive or negative) and normalizes it to an index between 0 and length - 1
 */
function normalizeIndex(index, length) {
    return mod(index, length) < 0
        ? length + 1 - Math.abs(mod(index, length))
        : mod(index, length);
}
export const Carousel = ({ index = 0, children, className }) => {
    const [_index, setIndex] = React.useState(index);
    useEffect(() => {
        setIndex(index);
    }, [index]);
    const slides = useMemo(() => React.Children.toArray(children), [children]);
    function slideRenderer(params) {
        const { index, key } = params;
        return (React.createElement("div", { key: key, className: "flex justify-center" }, slides.map((child, i) => i === normalizeIndex(index, slides.length) ? child : null)));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(InfiniteSwipeableViews, { "data-testid": "carousel", className: `pb-6${appendClassProps(className)}`, index: _index, onChangeIndex: (i) => setIndex(i), slideRenderer: slideRenderer }),
        React.createElement(Pagination, { dots: React.Children.count(children), index: normalizeIndex(_index, slides.length), onChangeIndex: (i) => setIndex(i) })));
};
//# sourceMappingURL=index.js.map